{
  "blocks": [
    {
      "id": "test-fsh",
      "kind": "test",
      "tags": ["testing", "her", "pre-cycle", "amh"],
      "title": "FSH",
      "subtitle": "Day 2-4 FSH for ovarian reserve",
      "body": {
        "testName": "Follicle-Stimulating Hormone (FSH)",
        "category": "blood-marker",
        "whatItMeasures": "FSH reflects the brain's signal to the ovaries and is interpreted with estradiol.",
        "howItWorks": "Blood draw on cycle day 2-4, most often day 2 or 3. Usually tested alongside estradiol and sometimes LH. Fasting is usually not required, but ask your clinic if it is bundled with other labs.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Blood"
          },
          {
            "kind": "time",
            "value": "5 min draw"
          },
          {
            "kind": "pain",
            "value": "Needle pinch"
          },
          {
            "kind": "prep",
            "value": "Cycle day 2-4"
          },
          {
            "kind": "results",
            "value": "1-2 business days"
          }
        ],
        "turnaroundTime": "1-2 business days",
        "costRange": {
          "low": 30,
          "high": 100
        },
        "cycleDay": "Day 2-4, most often day 2 or 3",
        "markerTiming": [
          {
            "marker": "FSH",
            "timing": "Cycle day 2-4, most often day 2 or 3",
            "reason": "Early follicular testing captures the baseline pituitary signal before a dominant follicle changes the hormone pattern."
          },
          {
            "marker": "Estradiol (if paired)",
            "timing": "Cycle day 2-4",
            "reason": "Estradiol helps interpret FSH because a high early estradiol level can suppress FSH."
          }
        ],
        "atHome": false,
        "clinicRequired": false,
        "dataPoints": ["dp-fsh-level"],
        "section": "ovarian-reserve"
      },
      "sources": [
        {
          "title": "Testing and interpreting measures of ovarian reserve: a committee opinion",
          "authors": "Practice Committee of the American Society for Reproductive Medicine",
          "journal": "Fertility and Sterility",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/testing-and-interpreting-measures-of-ovarian-reserve-a-committee-opinion-2020/",
          "evidenceLevel": "guideline"
        }
      ],
      "readTimeMinutes": 3
    }
  ],
  "relationships": [],
  "localeVariants": []
}
